/* eslint-disable @typescript-eslint/ban-types */
import { HoneyloveWindow } from '../models/HoneyloveWindow';
import { ShopifyCheckout } from '../models/ShopifyCheckout.model';
import { ShopifyLineItem } from '../models/ShopifyLineItem.model';
import {
  trackUserDetected,
  trackCheckoutStepEncountered,
  trackPurchase,
  trackPaymentGatewayUsed,
  trackPageInitialized,
  lineItemToProduct,
  lineItemToVariant,
  trackExperimentViewed,
} from './events.client';

declare const window: HoneyloveWindow;

// eslint-disable-next-line no-console
console.log('Script JS: tracking.bundle.js');

const trackRawCheckoutStepEncountered = (lineItems: ShopifyLineItem[], step: string, option: string) => {
  const productList = lineItems.map((lineItem: ShopifyLineItem) => ({
    product: lineItemToProduct(lineItem),
    variant: lineItemToVariant(lineItem),
  }));
  trackCheckoutStepEncountered(productList, step, option);
};

const trackRawPurchase = (shopifyCheckout: ShopifyCheckout, lineItems: ShopifyLineItem[]) => {
  const productList = lineItems.map((lineItem) => ({
    product: lineItemToProduct(lineItem),
    variant: lineItemToVariant(lineItem),
  }));
  trackPurchase(shopifyCheckout, productList);
};

export interface HoneyloveTracking {
  trackRawCheckoutStepEncountered: Function;
  trackRawPurchase: Function;
  trackUserDetected: Function;
  trackCheckoutStepEncountered: Function;
  trackPurchase: Function;
  trackPaymentGatewayUsed: Function;
  trackPageInitialized: Function;
  trackExperimentViewed: Function;
}

if (typeof window !== 'undefined') {
  window.honeyloveTracking = {
    trackRawCheckoutStepEncountered,
    trackRawPurchase,
    trackUserDetected,
    trackCheckoutStepEncountered,
    trackPurchase,
    trackPaymentGatewayUsed,
    trackPageInitialized,
    trackExperimentViewed,
  };
}
